import React, { useEffect, useState } from 'react';
import ProductCard from '../../components/ProductCard';
import Style from './Listing.module.scss';
import { ClientCardLoader } from '../../components';
import { makeApiCall } from '../../utils/makeApiCall';


const Listing = () => {
  const [fairs, setFairs] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    setLoading(true)

    try {
      const res = await makeApiCall({
        method: "GET",
        path: "/fairs"
      })
      setFairs(res.data)
      setLoading(false)
    } catch (err) {
      console.error(err);
      setLoading(false)
    }
  };

  useEffect(() => {
    fetchData()
  }, [])


  return (
    <div className="container">
      <div className={Style.container}>
        {loading &&
          <ClientCardLoader count={3} />
        }
        {fairs.length > 0 && fairs.map(client =>
          <ProductCard client={client} key={client.id} />
        )}
      </div>
    </div>
  )
}

export default Listing;